// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h_gyJ","right":"styles_right__14ZGy"};